import { getDarkenColor, hexToRgbA, getLightenColor } from "./";

export default (type, colors) => {
  const styles = {
    default: {
      'skip-to-content-link': {
        customCSS: `
          .skip-to-content-link,
          .skip-to-content-link:focus {
            background: ${getLightenColor(colors.secondary, 0.5)};
          }
        `
      },
      'c-image-upload__dropzone': {
        customCSS: `
          .c-image-upload__dropzone {
            color: ${colors.primary};
          }
          .c-image-upload__dropzone.state-dropzone-active, 
          .c-image-upload__dropzone:hover, 
          .c-image-upload__dropzone:active, 
          .c-image-upload__dropzone:focus {
            background: ${getLightenColor(colors.primary, 2.3)};
          }
          .c-image-upload__dropzone {
            border-color: ${getDarkenColor(colors.primary, 0.17)};
          }
          .c-image-upload__dropzone.state-invalid {
            border-color: ${colors.info};
          }
          .c-image-upload__dropzone .icon {
            color: ${colors.secondary_dark};
          }
        `
      },
      'item-list': {
        customCSS: `
          .item-list ul li:hover, 
          .item-list ul li:active, 
          .item-list ul li:focus {
            background: ${getDarkenColor(colors.light, 0.026)};
          }
          .item-list ul li .item-list__action:hover, 
          .item-list ul li .item-list__action:active, 
          .item-list ul li .item-list__action:focus {
            background: ${getDarkenColor(colors.light, 0.026)};
          }
        `
      },
      'help-text': {
        color: colors.offgray_dark
      }
    },
    type1: {
      'skip-to-content-link': {
        customCSS: `
          .skip-to-content-link,
          .skip-to-content-link:focus {
            background: ${getLightenColor(colors.secondary, 0.5)};
          }
        `
      },
      'c-image-upload__dropzone': {
        customCSS: `
          .c-image-upload__dropzone {
            color: ${colors.primary};
          }
          .c-image-upload__dropzone.state-dropzone-active, 
          .c-image-upload__dropzone:hover, 
          .c-image-upload__dropzone:active, 
          .c-image-upload__dropzone:focus {
            background: ${getLightenColor(colors.primary, 2.3)};
          }
          .c-image-upload__dropzone {
            border-color: ${getDarkenColor(colors.primary, 0.17)};
          }
          .c-image-upload__dropzone.state-invalid {
            border-color: ${colors.info};
          }
          .c-image-upload__dropzone .icon {
            color: ${colors.secondary_dark};
          }
        `
      }
    },
    'item-list': {
      customCSS: `
        .item-list ul li:hover, 
        .item-list ul li:active, 
        .item-list ul li:focus {
          background: ${getDarkenColor(colors.light, 0.026)};
        }
        .item-list ul li .item-list__action:hover, 
        .item-list ul li .item-list__action:active, 
        .item-list ul li .item-list__action:focus {
          background: ${getDarkenColor(colors.light, 0.026)};
        }
      `
    },
    'help-text': {
      color: colors.offgray_dark
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/misc.js